export enum ProductType {
  Test = "Test",
  Panel = "Panel",
  Package = "Package",
  SuperPackage = "SuperPackage",
  Kit = "Kit",
  VirtualConsultation = "VirtualConsultation",
  PhysicalConsultation = "PhysicalConsultation",
  Vaccination = "VACCINATION",
  Medication = "Medication",
}
